// src/version.js
export const VERSION = 'v0.7';
